import { apiLaravelClient } from '../utils/apiLaravelClient';

const secondaryBaseUrl = "/api/v0.1"

export function getPatientsVisitData() {
    return apiLaravelClient.get(`${secondaryBaseUrl}/videoroom/today/visits`);
}

export function getActiveCallHistory() {
	const data = {"callStatus" : ["On Call", "Waiting"]};
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/callhistory` , data);
}

export function getActiveCallDetails(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/call/details` , data);
}

export function getCallHistory() {
	const data = {"callStatus" : ["End Call"]};
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/callhistory` , data);
}

export function changeCallStatus(data) {
	data = {...data, source: "web"};
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/changestatus` , data);
}

export function changeCallField(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/update/field` , data);
}

export function changeUserStatus(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/users/updatestatus` , data);
}

export function getUserStatus(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/getstatus` , data);
}

export function updateCallTimeStatus(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/update/calltime` , data);
}

export function getGroupCallHistory(data) {
	if(!data){
		data = {
			offset: 0,
			limit: 20
		}
	}
	data = {...data, callStatus:["End Call"]};
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/new/callhistory` , data);
}
